import React from 'react'
import Page from '../templates/empower/wellbeing/spotlight/SpotLight-wow-health-and-vitality';

function spotlight() {
  return (
    <div>
      <Page/>
    </div>
  )
}

export default spotlight
